import { SideNavLayout } from "common/layouts/SideNavLayout";
import * as favoritesActions from "lib/api/favorites";
import { getCurrentUser } from "lib/utils";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { Analyze } from "../Analyze";
import { Calendar } from "../Calendar";
import { Collections } from "../Collections";
import { DashboardContainer } from "../Dashboard";
import { FeedContainer } from "../Feed";
import { MoreContainer } from "../More";
import { RidesContainer } from "../Rides";
import { RoutesContainer } from "../Routes";
import { Upload } from "../Upload";
import { HomepageSideNav } from "./HomepageSideNav";

export class DashLayout extends React.PureComponent {
  componentDidMount() {
    // hack to ensure proper display of route/ride pin state.
    // for full discussion, see:
    // https://github.com/ridewithgps/rwgps-ui/pull/1336#discussion_r260435351
    // and the follow-up
    // https://github.com/ridewithgps/ridewithgps/issues/6872
    const { currentUser, loadAllUserFavorites } = this.props;
    loadAllUserFavorites(currentUser.id);
  }

  render() {
    const { children, currentUser } = this.props;

    return <SideNavLayout greyBg nav={<HomepageSideNav user={currentUser} />} children={children} />;
  }
}

const mapStateToProps = (state) => ({ currentUser: state.currentUser });

const mapDispatchToProps = {
  loadAllUserFavorites: favoritesActions.loadAllUserFavorites,
};

const DashLayoutContainer = connect(mapStateToProps, mapDispatchToProps)(DashLayout);

const AppWrapper = ({ children }) => <DashLayoutContainer>{children}</DashLayoutContainer>;

const currentUser = getCurrentUser();
let homePath = (currentUser.preferences && currentUser.preferences["dashboard_home"]) || "dashboard";
if (homePath === "friends") homePath = "feed"; // TODO remove once preferences['dashboard_home'] migration happens
const routeDefs = [
  ["dashboard", DashboardContainer],
  ["calendar", Calendar],
  ["routes", RoutesContainer],
  ["rides", RidesContainer],
  ["collections", Collections],
  ["analyze", Analyze],
  ["upload", Upload],
  ["feed", FeedContainer],
  ["more", MoreContainer],
];

class HardRedirectToSlash extends React.PureComponent {
  componentDidMount() {
    window.location.href = "/";
  }

  render() {
    return null;
  }
}

const wrapped = (c) => <Wrapped c={c} w={currentUser.id ? AppWrapper : HardRedirectToSlash} />;
const Wrapped = ({ c: C, w: W }) => (
  <W>
    <C />
  </W>
);
export const routes = [
  routeDefs
    .map(([path, component]) =>
      homePath === path ? (
        [
          <Route key="slash" path="/" exact render={() => wrapped(component)} />,
          <Route key={path} path={`/${path}`} exact>
            <Redirect key={path} to="/" />
          </Route>,
        ]
      ) : (
        <Route key={path} exact path={`/${path}`} render={() => wrapped(component)} />
      )
    )
    .flat(),
];
